import {lazy, type ReactNode, Suspense} from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import {Sheet} from "@/components/Sheet";
import {GuardedStep} from "./components/GuardedStep";
import {LocationForm} from "./components/LocationForm";
import type {FlowStep} from "./hooks/useFlowState";
import {Order} from "./Order";

const Overview = lazy(() => import("./components/Overview").then((m) => ({default: m.Overview})));
const Confirmation = lazy(() =>
    import("./components/Confirmation").then((m) => ({default: m.Confirmation}))
);

const SheetSkeleton = () => <Sheet />;

type RouteConfig = {
    path: string;
    step: FlowStep;
    element: ReactNode;
};

const ROUTES: RouteConfig[] = [
    {
        path: "pickup",
        step: "pickup",
        element: <LocationForm type="pickup" />,
    },
    {
        path: "dropoff",
        step: "dropoff",
        element: <LocationForm type="dropoff" />,
    },
    {
        path: "overview",
        step: "overview",
        element: (
            <Suspense fallback={<SheetSkeleton />}>
                <Overview />
            </Suspense>
        ),
    },
    {
        path: "confirmation/:orderId",
        step: "confirmation",
        element: (
            <Suspense fallback={<SheetSkeleton />}>
                <Confirmation />
            </Suspense>
        ),
    },
];

export function OrderRoutes() {
    return (
        <Routes>
            <Route element={<Order />}>
                {ROUTES.map(({path, step, element}) => (
                    <Route
                        key={path}
                        path={path}
                        element={<GuardedStep step={step}>{element}</GuardedStep>}
                    />
                ))}
                <Route path="*" element={<Navigate to="/taxi/pickup" replace />} />
            </Route>
        </Routes>
    );
}
